import { render, staticRenderFns } from "./board-agile-column-setting.vue?vue&type=template&id=0884b47c&scoped=true&"
import script from "./board-agile-column-setting.vue?vue&type=script&lang=js&"
export * from "./board-agile-column-setting.vue?vue&type=script&lang=js&"
import style0 from "./board-agile-column-setting.vue?vue&type=style&index=0&id=0884b47c&scoped=true&lang=scss&"
import style1 from "./board-agile-column-setting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884b47c",
  null
  
)

export default component.exports